
















































































































import Vue from 'vue'
import { getInRoomLabel, getLastInRoomLabel, getPatientName, isInOwnRoom, isVibeOnline } from '@/utils/patients'
import { URGENT_EVENT_SEVERITY } from '@/utils/constants'
import { getEventDescription, getFriendlyEventName } from '@/view-model/patient-event-constants/MemberPatientEvents'
import { withDefault } from '@/components/exercises/measure/filters'
import StatusBadge from '@/components/sub-components/StatusBadge.vue'
import StatusLabel from '@/components/sub-components/StatusLabel.vue'
import { AUTO_REFRESH_PATIENTS, PATIENT_NOUN, SHOW_LOCATION_BY_VIBE } from '@/constants/app-variables'
import { mapActions, mapGetters, mapState } from 'vuex'
import { ModuleNames } from '@/store/module-names'
import { ActionNames as PatientActionNames, GetterNames as PatientGetterNames } from '@/store/modules/patient/keys'
import { COMMON_ICONS_BASE64, convertBase64ForSrc } from '@/utils/image-utils'
import { AppGetterNames } from '@/store/modules/app/keys'

export default Vue.extend({
  components: {
    StatusBadge,
    StatusLabel,
  },
  filters: { withDefault },
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    patients: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      refreshTime: 30 * 1000, // for temporary location info
      isStoppedRefreshing: false,
      isFetchingData: false,
      headers: [
        {
          text: PATIENT_NOUN + ' Name',
          sortable: true,
          value: 'patientName',
          width: '25%',
        },
        {
          text: PATIENT_NOUN + ' Status',
          sortable: true,
          value: 'patientStatus',
          width: '70%',
          sort: (a, b) => a.priority - b.priority,
        },
        SHOW_LOCATION_BY_VIBE
          ? {
              text: 'Location',
              sortable: true,
              value: 'patientLocation',
              width: 210,
            }
          : null,
        {
          text: 'Contact',
          sortable: true,
          value: 'contact',
          width: 120,
        },
        {
          text: 'Enrollment',
          sortable: true,
          value: 'enrollment',
          width: 160,
        },
        {
          text: 'Actions',
          sortable: false,
          value: 'actions',
          width: 80,
        },
      ].filter(it => !!it),
      statusColorMap: {
        active: this.$vuetify.theme.themes.light.green,
        completed: this.$vuetify.theme.themes.light.lavender,
      },
      statusLabelMap: {
        active: 'IN PROGRESS',
        completed: 'COMPLETED',
      },
      page: 1,
      pageCount: 1,
      sortBy: ['patientStatus', 'patientName'],
      sortDesc: [false, false],
    }
  },
  computed: {
    ...mapGetters(ModuleNames.patient, [PatientGetterNames.activePatients]),
    ...mapGetters(ModuleNames.app, {
      isAdminUser: AppGetterNames.isAdminUser,
      isExecUser: AppGetterNames.isExecUser,
    }),
    ...mapState(ModuleNames.patient, [PatientGetterNames.activePatients]),
    canEditPatients(): Boolean {
      return this.isAdminUser
    },
    convertedPatientsForDataTable(): any[] {
      return this.patients.map(patient => ({
        id: patient.id,
        patientName: getPatientName(patient),
        patientStatus: this.getPatientStatus(patient),
        patientStatusDescription: this.getPatientStatusDescription(patient),
        patientLocation: this.getPatientLocation(patient),
        patientLocationDescription: getLastInRoomLabel(patient, true),
        contact: patient.phoneNumber,
        enrollment: this.getPatientEnrollment(patient),
        actions: [
          {
            label: 'EDIT PROFILE',
            color: 'primary',
            onClick: this.onClickEditProfile(patient.id),
          },
          {
            label: 'RETURN PACKAGE',
            color: 'red',
            onClick: this.onClickRemovePackage(patient.id),
          },
        ],
      }))
    },
    iconImage(): string {
      return convertBase64ForSrc(COMMON_ICONS_BASE64.INFO_CIRCLE)
    },
    showLoading(): Boolean {
      //combines loading states from props and data
      return this.loading || this.isFetchingData
    },
  },
  async mounted() {
    //await this[PatientActionNames.getPatients]()
    this.resumeRefreshing()
  },
  beforeDestroy(): void {
    this.stopRefreshing()
  },
  methods: {
    ...mapActions(ModuleNames.patient, [PatientActionNames.getPatients]),
    async fetchData() {
      this.isFetchingData = true
      console.log('fetchData()!')
      await this[PatientActionNames.getPatients]()
      this.isFetchingData = false
    },
    stopRefreshing() {
      this.isStoppedRefreshing = true
    },
    resumeRefreshing() {
      this.isStoppedRefreshing = false
      this.startRefreshing()
    },
    startRefreshing() {
      if (this.isStoppedRefreshing) return
      if (!AUTO_REFRESH_PATIENTS) return
      setTimeout(async () => {
        try {
          await this.fetchData()
        } catch (e) {
          console.log('error', e)
        }
        this.startRefreshing()
      }, this.refreshTime)
    },
    getPatientStatus(patient): { label: string; color: string; priority: number } {
      if (patient.patientEvent === null) {
        return {
          label: 'On Track',
          color: this.$vuetify.theme.themes.light.green,
          priority: 3,
        }
      }

      if (patient.patientEvent.eventSeverity < URGENT_EVENT_SEVERITY) {
        return {
          label: getFriendlyEventName(patient.patientEvent.eventName),
          color: this.$vuetify.theme.themes.light.orange,
          priority: 2,
        }
      } else {
        return {
          label: getFriendlyEventName(patient.patientEvent.eventName),
          color: this.$vuetify.theme.themes.light.red,
          priority: 1,
        }
      }
    },
    getPatientStatusDescription(patient): string {
      if (patient.patientEvent === null) {
        return null
      }
      return getEventDescription(patient.patientEvent.eventName)
    },
    getPatientLocation(patient): { label: string; color: string } {
      // no recent data
      if (patient.lastTrackerConnectionTimestamp === null || !isVibeOnline(patient)) {
        return {
          label: getInRoomLabel(patient),
          color: 'lightgrey', //this.$vuetify.theme.themes.light.,
        }
      }

      // if older than 5 minutes for now!
      if (!isInOwnRoom(patient)) {
        return {
          label: getInRoomLabel(patient),
          color: this.$vuetify.theme.themes.light.warning,
        }
      } else {
        return {
          label: getInRoomLabel(patient),
          color: this.$vuetify.theme.themes.light.info,
        }
      }
    },
    getPatientEnrollment(patient): { label: string; color: string } {
      const status = patient.status.toLowerCase()
      return {
        label: this.statusLabelMap[status],
        color: this.statusColorMap[status],
      }
    },
    onClickEditProfile(patientId) {
      return () => this.$emit('editPatientAction', patientId)
      /*
      return () => this.$router.push({ name: 'edit-detailed-patient', params: { patient_id: patientId } })
      */
    },
    onClickRemovePackage(patientId) {
      return () => this.$emit('removePackageFromPatientAction', patientId)
    },
  },
})
